import { defaultStatus } from '../defaultState/defaultState';
import {
    ADD_TRANSFER_PATIENT_FAILURE,
    ADD_TRANSFER_PATIENT_REQUEST,
    ADD_TRANSFER_PATIENT_SUCCESS,
    DELETE_TRANSFER_PATIENT_FAILURE,
    DELETE_TRANSFER_PATIENT_REQUEST,
    DELETE_TRANSFER_PATIENT_SUCCESS,
    FETCH_LIST_TRANSFER_PATIENT_FAILURE,
    FETCH_LIST_TRANSFER_PATIENT_REQUEST,
    FETCH_LIST_TRANSFER_PATIENT_SUCCESS,
    FETCH_TRANSFER_PATIENT_FAILURE,
    FETCH_TRANSFER_PATIENT_REQUEST,
    FETCH_TRANSFER_PATIENT_SUCCESS,
    HISTORY_TRANSFER_PATIENT_FAILURE,
    HISTORY_TRANSFER_PATIENT_REQUEST,
    HISTORY_TRANSFER_PATIENT_SUCCESS,
    RESET_CURRENT_TRANSFER_PATIENT,
    UPDATE_TRANSFER_PATIENT_FAILURE,
    UPDATE_TRANSFER_PATIENT_REQUEST,
    UPDATE_TRANSFER_PATIENT_SUCCESS
} from './transferPatientType';

const initialState = {
  addTransferPatients: { ...defaultStatus },
  deleteTransferPatient: { ...defaultStatus },
  fetchListTransferPatient: { ...defaultStatus },
  fetchTransferPatient: { ...defaultStatus },
  updateTransferPatient: { ...defaultStatus },
  historyTransferPatient: { ...defaultStatus }
}

const transferPatientReducer = (state = initialState, action) => {
  const { type, payload } = action || {};

  switch (type) {
    case FETCH_LIST_TRANSFER_PATIENT_REQUEST:
      return {
        ...state,
        fetchListTransferPatient: {
          ...state.fetchListTransferPatient,
          inProgress: true,
          error: null
        }
      }
    case FETCH_LIST_TRANSFER_PATIENT_SUCCESS:
      return {
        ...state,
        fetchListTransferPatient: {
          ...state.fetchListTransferPatient,
          inProgress: false,
          success: true,
          data: payload?.transferPatient?.data
        },
      }
    case FETCH_LIST_TRANSFER_PATIENT_FAILURE:
      return {
        ...state,
        fetchListTransferPatient: {
          ...state.fetchListTransferPatient,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }
    case HISTORY_TRANSFER_PATIENT_REQUEST:
      return {
        ...state,
        historyTransferPatient: {
          ...state.fetchListTransferPatient,
          inProgress: true,
          error: null
        }
      }
    case HISTORY_TRANSFER_PATIENT_SUCCESS:
      return {
        ...state,
        historyTransferPatient: {
          ...state.fetchListTransferPatient,
          inProgress: false,
          success: true,
          data: payload?.transferPatient?.data
        },
      }
    case HISTORY_TRANSFER_PATIENT_FAILURE:
      return {
        ...state,
        historyTransferPatient: {
          ...state.fetchListTransferPatient,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    case FETCH_TRANSFER_PATIENT_REQUEST:
      return {
        ...state,
        fetchTransferPatient: { ...state.fetchTransferPatient, inProgress: true, error: null }
      }
    case FETCH_TRANSFER_PATIENT_SUCCESS:
      return {
        ...state,
        fetchTransferPatient: {
          ...state.fetchTransferPatient,
          inProgress: false,
          success: true,
          data: payload?.transferPatient?.data,
        },
      }
    case FETCH_TRANSFER_PATIENT_FAILURE:
      return {
        ...state,
        fetchTransferPatient: {
          ...state.fetchTransferPatient,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    case ADD_TRANSFER_PATIENT_REQUEST:
      return {
        ...state,
        addTransferPatients: {
          ...state.addTransferPatients,
          inProgress: true,
          success: false,
          error: null,
          errorMessage: null
        }
      };
    case ADD_TRANSFER_PATIENT_SUCCESS:
      return {
        ...state,
        addTransferPatients: {
          ...state.addTransferPatients,
          inProgress: false,
          success: true,
          data: payload?.transferPatients
        },
      };
    case ADD_TRANSFER_PATIENT_FAILURE:
      return {
        ...state,
        addTransferPatients: {
          ...state.addTransferPatients,
          inProgress: false,
          success: false,
          error: true,
          errorMessage: payload?.error || null,
          ...payload
        }
      };

    case UPDATE_TRANSFER_PATIENT_REQUEST:
      return {
        ...state,
        updateTransferPatient: { ...state.updateTransferPatient, inProgress: true, error: null }
      }
    case UPDATE_TRANSFER_PATIENT_SUCCESS: {
      return {
        ...state,
        updateTransferPatient: {
          ...state.addTransferPatient,
          inProgress: false,
          success: true,
          data: payload?.transferPatient
        },
      }
    }
    case UPDATE_TRANSFER_PATIENT_FAILURE:
      return {
        ...state,
        updateTransferPatient: {
          ...state.addTransferPatient,
          inProgress: false,
          success: false,
          error: true,
          errorMessage: payload?.errorMessage || null,
          ...payload
        }
      }

    case DELETE_TRANSFER_PATIENT_REQUEST:
      return {
        ...state,
        deleteTransferPatient: { ...state.deleteTransferPatient, inProgress: true, error: null }
      }
    case DELETE_TRANSFER_PATIENT_SUCCESS:
      return {
        ...state,
        deleteTransferPatient: {
          ...state.deleteTransferPatient,
          inProgress: false,
          success: true
        },
        transferPatient: {
          ...state.transferPatient,
          data: state.transferPatient.data.filter(
            transferPatient => transferPatient.id !== payload.transferPatientId
          )
        },
        currentTransferPatient:
          state.currentTransferPatient.data?.id === payload.transferPatientId
            ? { ...defaultStatus, data: null }
            : state.currentTransferPatient
      }
    case DELETE_TRANSFER_PATIENT_FAILURE:
      return {
        ...state,
        deleteTransferPatient: {
          ...state.deleteTransferPatient,
          inProgress: false,
          error: true,
          errorMessage: payload.error
        }
      }

    case RESET_CURRENT_TRANSFER_PATIENT:
      return { ...defaultStatus }

    default:
      return state
  }
}

export default transferPatientReducer